<ng-container *ngIf="isShow">
    <app-loading-animation 
        [isRouting]="!cards" 
        [margin]="'27px auto'"
        [width]="80"
        [height]="20"
        [background]="'none'"
    >
        <ng-container *ngFor="let card of cards; let index = index">
            <div class="pay-w-defined-card" (click)="onCardSubmit(card)">
                <div class="card-icon">
                    <img src="../../../../assets/images/widget_card.png"/>
                </div>
                <div class="card-type-info">{{card.maskedPan}}</div>
            </div>
        </ng-container>
    </app-loading-animation>
</ng-container>